import axios from "@/utils/request";

/**
 * 点检项目组分页列表（「选择点检项目组」弹窗数据源，支持下拉分页）
 *
 * 来源：PC 端 GetCheckItemGroupList
 *   PC url：/isc/ems/PmItemGroup/GetPmItemGroupPageList
 *   H5 url：按本项目网关前缀惯例（/isc_ems + 服务内路径）拼接
 *
 * 传参与 PC 端保持一致，另需固定传 group_type=1（点检项目组）
 * @param {Object} data { company_id, page, pageSize }
 * @returns { code, rows, total }
 */
export function GetCheckItemGroupList(data) {
  return axios({
    url: "/isc_ems/isc/ems/PmItemGroup/GetPmItemGroupPageList",
    method: "post",
    // group_type 写死为 1：只取点检项目组
    data: { group_type: 1, ...(data || {}) },
  });
}

/**
 * 按项目组 id 获取点检项明细
 *
 * 该接口不支持一次返回全部明细，只能在展开某个项目组时按 group_id 单独请求。
 * group_id 取 GetCheckItemGroupList 返回行（GetPmItemGroupPageList）的 id。
 *
 * @param {Object} data { group_id }
 */
export function GetCheckItemListByGroupId(data) {
  return axios({
    url: "/isc_ems/isc/ems/PmCheckItem/GetCheckItemListByGroupId",
    method: "post",
    data,
  });
}
